// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"LoadingOverlay_loadingContainer__2uGZI","spinner":"LoadingOverlay_spinner__Nj2Bl","spinnerLoading":"LoadingOverlay_spinnerLoading__2HpkY"};